import { defineMessages } from "../i18n/core";

export const machinesMessages = defineMessages({
  "pt-BR": {
    title: "Máquinas",
    lede: "Cada linha mostra os últimos 30 dias de pontos de restauração.",
    addMachines: "Adicionar máquinas",
    statusFilter: "Filtrar por status",
    all: "Todas",
    groupFilter: "Filtrar por grupo",
    allGroups: "Todos os grupos",
    search: "Buscar hostname",
    colMachine: "Máquina",
    colStatus: "Status",
    colLast30: "Últimos 30 dias",
    colLastBackup: "Último backup",
    colProtected: "Protegido",
    colAgent: "Agente",
    never: "nunca",
    online: "online",
    seen: (when: string) => `visto ${when}`,
    empty: "Nenhuma máquina corresponde aos filtros.",
  },
  "en-US": {
    title: "Machines",
    lede: "Each row shows the last 30 days of restore points.",
    addMachines: "Add machines",
    statusFilter: "Filter by status",
    all: "All",
    groupFilter: "Filter by group",
    allGroups: "All groups",
    search: "Search hostname",
    colMachine: "Machine",
    colStatus: "Status",
    colLast30: "Last 30 days",
    colLastBackup: "Last backup",
    colProtected: "Protected",
    colAgent: "Agent",
    never: "never",
    online: "online",
    seen: (when: string) => `seen ${when}`,
    empty: "No machines match the filters.",
  },
  es: {
    title: "Equipos",
    lede: "Cada fila muestra los últimos 30 días de puntos de restauración.",
    addMachines: "Agregar equipos",
    statusFilter: "Filtrar por estado",
    all: "Todos",
    groupFilter: "Filtrar por grupo",
    allGroups: "Todos los grupos",
    search: "Buscar hostname",
    colMachine: "Equipo",
    colStatus: "Estado",
    colLast30: "Últimos 30 días",
    colLastBackup: "Última copia",
    colProtected: "Protegido",
    colAgent: "Agente",
    never: "nunca",
    online: "en línea",
    seen: (when: string) => `visto ${when}`,
    empty: "Ningún equipo coincide con los filtros.",
  },
});
